import { useMutation, useQuery } from '@apollo/client'
import { captureWarning } from 'lib/monitoring'
import { GET_ROOM_VIEW_SCHEDULED_SURGERIES } from '../graphql/query'
import { useApolloClients } from 'lib/apollo/apolloProvider'
import {
  TGetRoomViewScheduledSurgeriesInput,
  TGetRoomViewScheduledSurgeriesResponse,
  TUpdatePatientStatusResponse,
  TUpdatePatientStatusVariables,
} from '../RoomView.types'
import { UPDATE_ROOM_VIEW_PATIENT_STATUS } from '../graphql/mutation'

export const useGetRoomViewScheduledSurgeries = (
  variables: TGetRoomViewScheduledSurgeriesInput
) => {
  const { iservicesClient: client } = useApolloClients()
  return useQuery<
    TGetRoomViewScheduledSurgeriesResponse,
    TGetRoomViewScheduledSurgeriesInput
  >(GET_ROOM_VIEW_SCHEDULED_SURGERIES, {
    variables,
    client,
    fetchPolicy: 'no-cache',
    onError: (e: Error) => {
      captureWarning(e)
    },
  })
}

export const useUpdatePatientStatusMutation = () => {
  const { iservicesClient: client } = useApolloClients()
  return useMutation<
    TUpdatePatientStatusResponse,
    TUpdatePatientStatusVariables
  >(UPDATE_ROOM_VIEW_PATIENT_STATUS, {
    client,
    onError: (e: Error) => {
      captureWarning(e)
      throw e
    },
  })
}
